import angular from "angular";
import $ from 'jquery';
import { cloneDeep } from "lodash";

angular
    .module('ui-sentinel.shipments.shipmentNew')
    .directive('shipmentNewAlarms', ShipmentNewAlarmsDirective);

function ShipmentNewAlarmsDirective() {
    var directive = {
        restrict: 'A',
        scope: {
            device: '=',
            alarms: '='
        },
        controller: ThisDirectiveController,
        controllerAs: 'shipmentNewAlarms',
        bindToController: true,
        template: require('./shipment-new-alarms-directive.html'),
        link: link
    };
    return directive;

    function link(scope, element, attrs, controller) {
    }

}

ThisDirectiveController.$inject = ['$rootScope', '$state', 'DevicesService', 'AlarmsService', 'SentinelUiSession', 'FeedbackService'];

function ThisDirectiveController($rootScope, $state, DevicesService, AlarmsService, SentinelUiSession, FeedbackService) {
    var vm = {
        feedback: FeedbackService,
        actions: {
            toggleAlarm: toggleAlarm,
            goToAlarm: goToAlarm
        },
        load: load
    };
    activate();
    return vm;

    function activate() {
        load();
    }

    function goToAlarm(alarmId) {
        const returnState = $state.current.name;
        const returnStateParams = cloneDeep($state.params);
        $state.go('alarm.admin', { alarmId: alarmId, referrer: returnState, referrerParams: returnStateParams });
    }

    function load() {
        vm.alarms = [];

        var promise = (SentinelUiSession.user.isAnAdmin && (SentinelUiSession.user.accountId == SentinelUiSession.focus.id)) ?
            AlarmsService.getAlarms(SentinelUiSession.focus).$promise : AlarmsService.getAlarmsAccount(SentinelUiSession.focus).$promise;
        $rootScope.loading = true;
        promise.then(
            function (result) {
                $rootScope.loading = false;
                _.forEach(result, function (alarm) {
                    //TODO check if is it necesary the filter or not
                    if (alarm.alarmType != "device") {
                        vm.alarms.push(angular.extend(alarm, { isAdded: false }));
                    }
                });
                //loadAssigned();   //skipping this feature until templates include preselected alarms
            },
            function (error) {
                $rootScope.loading = false;
                vm.feedback.addErrorFromError(error);
            }
        );
    }

    function loadAssigned() {
        if (!vm.device) {
            return;
        }

        var promise = DevicesService.getAlarms(vm.device).$promise;
        promise.then(
            function (result) {
                _.forEach(result, function (assignedAlarm) {
                    _.forEach(vm.alarms, function (availableAlarm) {
                        if (assignedAlarm.alarmId === availableAlarm.alarmId) {
                            availableAlarm.isAdded = true;
                        }
                    });
                });
            },
            function (error) {
                vm.feedback.addErrorFromError(error);
            }
        );
    }

    function toggleAlarm(alarm) {
        $('#btn-toggle-alarm-' + alarm.alarmId).blur();
        alarm.isAdded = !alarm.isAdded;
    }
}
